<div class="ExpandingList" data-test-id="expandinglist" @accordion>
  @for (
    listItem of list | slice: 0 : limit;
    track listItem;
    let index = $index
  ) {
    @if ((index < lineCount && !isExpanded) || isExpanded) {
      <div class="ExpandingList__Item" [innerHTML]="listItem"></div>
    }
  }
  @if (listLength > lineCount) {
    <zip-button
      class="ExpandingList__Button"
      [config]="{
        level: 'text',
        content: buttonText,
        icon: buttonIcon,
      }"
      (click)="showHide()"
    ></zip-button>
  }
</div>
